/*
  Doppelklick auf einen Eintrag in der Mitarbeitenden-Ansicht: anzeigen.
  Bewusst nicht der Schicht-Editor mit gesperrten Feldern - hier gibt es keinen
  Speicherweg, den man vergessen könnte zu sperren. Einzige Ausnahme ist der
  Kommentar des eigenen Eintrags (Web page.shiftplan/employee_entry_comments), den der
  Server ebenso nur für eigene, freigegebene Einträge annimmt.
*/

import React, { useEffect, useState } from "react";
import AppButton from "../../../design-system/components/AppButton";
import AppDialog from "../../../design-system/components/AppDialog";
import AppDialogBody from "../../../design-system/components/AppDialogBody";
import AppDialogFooter from "../../../design-system/components/AppDialogFooter";
import AppDialogHeader from "../../../design-system/components/AppDialogHeader";
import AppField from "../../../design-system/components/AppField";
import AppText from "../../../design-system/components/AppText";
import AppTextarea from "../../../design-system/components/AppTextarea";

const COMMENT_MAX_LENGTH = 500; // Timetable.note

export default function EntryDetailsDialog({ details, onClose, onSaveComment }) {
  const editableComment = onSaveComment ? details?.editableComment || null : null;
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    setComment(editableComment?.value || "");
    setSaveError("");
    setSaving(false);
  }, [editableComment?.entryId, editableComment?.value]);

  const handleSave = async () => {
    setSaving(true);
    setSaveError("");
    try {
      await onSaveComment(editableComment.entryId, comment);
    } catch (error) {
      setSaveError(error?.response?.data?.message || "Der Kommentar konnte nicht gespeichert werden.");
      setSaving(false);
    }
  };

  return (
    <AppDialog open={Boolean(details)} onClose={onClose} size="sm">
      <AppDialogHeader title={details?.title || ""} subtitle={details?.subtitle || ""} />
      <AppDialogBody>
        <dl className="employee-entry-details">
          {(details?.rows || []).map((row) => (
            <div key={row.label} className="employee-entry-details__row">
              <AppText as="dt" variant="label-2" tone="secondary">
                {row.label}
              </AppText>
              <AppText as="dd" variant="body-1">
                {row.value}
              </AppText>
            </div>
          ))}
        </dl>
        {editableComment ? (
          <AppField label="Kommentar" help="Für alle sichtbar." error={saveError}>
            <AppTextarea
              rows={3}
              value={comment}
              maxLength={COMMENT_MAX_LENGTH}
              disabled={saving}
              onChange={(event) => setComment(event.target.value)}
            />
          </AppField>
        ) : null}
      </AppDialogBody>
      <AppDialogFooter>
        {editableComment ? (
          <>
            <AppButton onClick={onClose} disabled={saving}>
              Abbrechen
            </AppButton>
            <AppButton variant="primary" onClick={handleSave} disabled={saving}>
              Speichern
            </AppButton>
          </>
        ) : (
          <AppButton variant="primary" onClick={onClose}>
            Schliessen
          </AppButton>
        )}
      </AppDialogFooter>
    </AppDialog>
  );
}
